import React from "react";
import { Helmet } from "react-helmet-async";

/* =========================================================
   GLOBAL SEO CONFIGURATION
========================================================= */

const SITE_NAME = "Bairagi Consultants";

const BASE_URL = "https://www.bairagi-consultants.com";

const DEFAULT_IMAGE = "/logo512.png";

const DEFAULT_DESCRIPTION =
  "Bairagi Consultants provides custom software development, ecommerce development, mobile apps, CRM, ERP, MIS, AI solutions and business automation services.";


/* =========================================================
   SEO COMPONENT
========================================================= */

const SEO = ({
  title,
  description = DEFAULT_DESCRIPTION,
  path = "/",
  image = DEFAULT_IMAGE,
  type = "website",
  noIndex = false,
  schema = null,
}) => {

  /* ---------------------------------------------------------
     BUILD CANONICAL URL
  --------------------------------------------------------- */

  const normalizedPath =
    path === "/"
      ? "/"
      : `/${path.replace(/^\/+|\/+$/g, "")}`;

  const canonicalUrl = `${BASE_URL}${normalizedPath}`;


  /* ---------------------------------------------------------
     BUILD SOCIAL IMAGE URL
  --------------------------------------------------------- */

  const imageUrl = image.startsWith("http")
    ? image
    : `${BASE_URL}${
        image.startsWith("/") ? image : `/${image}`
      }`;


  /* ---------------------------------------------------------
     PAGE TITLE
  --------------------------------------------------------- */

  const pageTitle =
    title || `${SITE_NAME} | Custom Software Development Company`;


  return (
    <Helmet>

      {/* =====================================================
          BASIC SEO
      ====================================================== */}

      <title>{pageTitle}</title>

      <meta
        name="description"
        content={description}
      />

      <meta
        name="robots"
        content={
          noIndex
            ? "noindex, nofollow"
            : "index, follow, max-image-preview:large"
        }
      />


      {/* =====================================================
          CANONICAL URL
      ====================================================== */}

      <link
        rel="canonical"
        href={canonicalUrl}
      />


      {/* =====================================================
          OPEN GRAPH / FACEBOOK / LINKEDIN
      ====================================================== */}

      <meta
        property="og:type"
        content={type}
      />

      <meta
        property="og:site_name"
        content={SITE_NAME}
      />

      <meta
        property="og:title"
        content={pageTitle}
      />

      <meta
        property="og:description"
        content={description}
      />

      <meta
        property="og:url"
        content={canonicalUrl}
      />

      <meta
        property="og:image"
        content={imageUrl}
      />

      <meta
        property="og:image:alt"
        content={`${SITE_NAME} - Software Development Company`}
      />


      {/* =====================================================
          TWITTER / X
      ====================================================== */}

      <meta
        name="twitter:card"
        content="summary_large_image"
      />

      <meta
        name="twitter:title"
        content={pageTitle}
      />

      <meta
        name="twitter:description"
        content={description}
      />

      <meta
        name="twitter:image"
        content={imageUrl}
      />


      {/* =====================================================
          STRUCTURED DATA / JSON-LD
      ====================================================== */}

      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}

    </Helmet>
  );
};

export default SEO;